<template>
  <div>
    <el-popover
      placement="bottom-start"
      trigger="hover"
    >
      <div class="feet">
        <!--下载模板-->
        <el-button
          class="feet-btn"
          type="primary"
          size="small"
          @click="onDownloadTemplate"
        >{{ $t('basicData.DownloadTheTemplate') }}</el-button>
        <!--批量导入-->
        <upload-excel
          class="feet-btn"
          :on-success="importLogistics"
          :but-name="$t('basicData.BulkImport')"
        />
        <!--下载报价-->
        <el-button
          class="feet-btn"
          type="primary"
          size="small"
          @click="downloadOffer"
        >{{ $t('basicData.DownloadTheQuote') }}</el-button>
      </div>
      <!--导入/下载-->
      <template #reference>
        <el-button size="small" plain>{{ $t('basicData.ImportDownload') }}</el-button>
      </template>
    </el-popover>
  </div>
</template>

<script>
import { downloadTemplate, importTemplate, downloadQuotation } from './utils';

export default {
  components: {
    'upload-excel': () => import('@/components/UploadExcel/index.vue')
  },

  props: {
    // 费用类型
    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 车线数据
    stitchingLine: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 车型
    modelList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 下载模板需要的回调函数
    getDataFunc: {
      type: Function,
      required: true
    },
    // 报价类型 1-车线报价 2-通用报价
    quotationType: {
      type: [String, Number],
      default: ''
    }
  },

  methods: {
    // 下载模板
    onDownloadTemplate() {
      downloadTemplate(this.stitchingLine, this.modelList, this.feeTypeList, this.quotationType);
    },

    // 批量导入报价
    importLogistics(arr) {
      console.log(arr, '干支线导入');

      try {
        const results = arr[0].results.slice(1);
        const list = importTemplate(results);
        console.log(list, '解析数据');
        this.$message.success(this.$t('orderCenterCont.ImportWasSuccessful'));
        this.$emit('importList', list);
      } catch (error) {
        this.$message.warning(this.$t('orderCenterCont.ImportFailed'));
        console.error(error);
      }
    },

    // 下载报价
    downloadOffer() {
      const list = this.getDataFunc();
      downloadQuotation(list, this.stitchingLine, this.modelList, this.feeTypeList, this.quotationType);
    }
  }
};
</script>

